<div class="compare-bar">
  <button *ngFor="let size of items" mat-button class="item-button" (click)="sizeClick(size)" matTooltip="Click to remove">
    <img [src]="size.imagePath()" />
    <span class="label">{{ size.name }}</span>
  </button>
  <button mat-button color="accent" class="compare-button" (click)="compareClick()">Compare</button>
  <button mat-button color="accent" class="clear-button" (click)="clearClick()">Clear All</button>
</div>